import { PermissionCategories, Permissions } from "cpl-react-common/components/Enums/Permissions";
import { ISessionService } from "services/SessionService";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export function checkUserHasPermission(permissionPredicate: (permission: Permissions) => boolean): boolean {
  const permissions = getUserPermissions();
  if (permissions.length < 1) {
    return false;
  }
  const permission = permissions.find((permission) => permissionPredicate(permission.p));

  if (permission !== null && permission !== undefined) {
    return true;
  }
  return false;
}

export function checkUserHasAnyInCategory(
  permissionCategoryPredicate: (permissionCategory: PermissionCategories) => boolean
): boolean {
  const permissions = getUserPermissions();

  if (permissions.length < 1) {
    return false;
  }
  const permission = permissions.find(
    (permission) =>
      permissionCategoryPredicate(permission.c) || (permission.m != null && permissionCategoryPredicate(permission.m))
  );

  if (permission !== null && permission !== undefined) {
    return true;
  }
  return false;
}

function getUserPermissions() {
  const sessionService = container.get<ISessionService>(SERVICE_TYPES.SessionService);
  return sessionService.getUserPermissionClaims();
}
